import { Typography, Card, Input } from "@mui/joy";

const RecursiveEditableItems = ({ item, onChange, depth = 0 }) => {
  if (typeof item !== "object" || item === null) {
    return (
      <Input
        value={item ?? ""}
        onChange={(e) => onChange(e.target.value)}
        sx={{ mb: 1 }}
      />
    );
  }

  const handleNestedChange = (key, newValue) => {
    onChange({ ...item, [key]: newValue });
  };

  return (
    <>
      {Object.entries(item).map(([key, value]) => (
        <div key={key} style={{ paddingLeft: depth * 10 }}>
          <Typography level="body-sm"><strong>{key}</strong>: </Typography>
          {typeof value === "object" && value !== null ? (
            Array.isArray(value) ? (
              value.map((val, index) => (
                <Card key={index} variant="outlined" sx={{ my: 1, px: 1 }}>
                  <RecursiveEditableItems
                    item={val}
                    onChange={(valUpdate) =>
                      handleNestedChange(
                        key,
                        [...value.slice(0, index), valUpdate, ...value.slice(index + 1)]
                      )
                    }
                    depth={depth + 1}
                  />
                </Card>
              ))
            ) : (
              <RecursiveEditableItems
                item={value}
                onChange={(val) => handleNestedChange(key, val)}
                depth={depth + 1}
              />
            )
          ) : (
            <Input
              name={key}
              value={value ?? ""}
              onChange={(e) => handleNestedChange(key, e.target.value)}
              sx={{ mb: 1 }}
            />
          )}
        </div>
      ))}
    </>
  );
};

export default RecursiveEditableItems;
